import { render, staticRenderFns } from "./gradeDetailassessment.vue?vue&type=template&id=1e50220e&scoped=true"
import script from "./gradeDetailassessment.vue?vue&type=script&lang=js"
export * from "./gradeDetailassessment.vue?vue&type=script&lang=js"
import style0 from "./gradeDetailassessment.vue?vue&type=style&index=0&id=1e50220e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e50220e",
  null
  
)

export default component.exports